import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faFacebookF, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  const footerColumns = {
    clientResources: [
      { href: '#', label: 'Our Team' },
      { href: '#', label: 'Our Mission, Vision, and Values' },
      { href: '#', label: 'Contact Us' },
      { href: '#', label: 'Accepted Insurance Plans' },
      { href: '#', label: 'Community Mental Health Resources' },
    ],
    services: [
      { href: '#', label: 'One-on-One Therapy' },
      { href: '#', label: 'Couples & Relationship Counseling' },
      { href: '#', label: 'Group-Based Therapy Programs' },
      { href: '#', label: 'Mental Health Services for Students & Youth' },
      { href: '#', label: 'Psychiatric Care & Medication Support' },
    ],
    assesements: [
      { href: '#', label: 'Autism Spectrum Evaluation' },
      { href: '#', label: 'Learning and Developmental Assessments' },
      { href: '#', label: 'Psychological and Specialized Evaluations' },
      { href: '#', label: 'Speech and Communication Assessments' },
    ],
  };

  return (
    <footer className="primary-bg text-white">
      <div className="mx-auto px-6 md:px-10 lg:px-16 py-10">
        <div className="grid grid-cols-1 md:grid-cols-10 gap-8">

          {/* Left Section - Logo and Description */}
          <div className="md:col-span-3">
            <Link to="/">
              <img src='/assets/images/footer-logo.svg' alt="Avexa Logo" className="h-10 w-auto mb-4" />
            </Link>
            <p className="text-sm leading-relaxed mb-2" style={{ color: 'var(--white)' }}>
              At Avexa, we're building the future of health—
            </p>
            <p className="text-sm leading-relaxed mb-6" style={{ color: 'var(--white)' }}>
              intelligent, connected, and made for everyone.
            </p>

            {/* Contact Info */}
            <div className="mb-6">
              <h3 className="text-base font-bold mb-3 secondary-text">Contact</h3>
              <p className="text-sm mb-2" style={{ color: 'var(--white)' }}>
                <a href="mailto:info@avexasystems.com" className="hover:opacity-80 transition">
                  info@avexasystems.com
                </a>
              </p>
              <p className="text-sm" style={{ color: 'var(--white)' }}>
                <a href="tel:+1-555-123-4567" className="hover:opacity-80 transition">
                  040 4831827
                </a>
              </p>
            </div>

            {/* Stay Connected */}
            <div>
              <h3 className="text-base font-bold mb-3 secondary-text">Stay Connected</h3>
              <div className="flex gap-3">
                <a
                  href="#"
                  // target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition"
                >
                  <FontAwesomeIcon icon={faFacebookF} style={{ color: 'var(--white)' }} className="text-sm" />
                </a>
                <a
                  href="#"
                  // target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition"
                >
                  <FontAwesomeIcon icon={faTwitter} style={{ color: 'var(--white)' }} className="text-sm" />
                </a>
                
                <a
                  href="#"
                  // target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition"
                >
                  <FontAwesomeIcon icon={faInstagram} style={{ color: 'var(--white)' }} className="text-sm" />
                </a>
                <a
                  href="#"
                  // target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition"
                >
                  <FontAwesomeIcon icon={faLinkedinIn} style={{ color: 'var(--white)' }} className="text-sm" />
                </a>
              </div>
            </div>
          </div>

          {/* Right Section - Footer Links */}
          <div className="md:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">

              {/* Column 1 - Who We Are */}
              <div>
                <h3 className="text-base font-bold mb-4 secondary-text">Client Resources</h3>
                <ul className="space-y-2">
                  {footerColumns.clientResources.map((link, index) => (
                    <li key={`who-${index}`}>
                      <Link
                        to={link.href}
                        className="text-sm hover:opacity-80 transition block"
                        style={{ color: 'var(--white)' }}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Column 2 - Platforms */}
              <div>
                <h3 className="text-base font-bold mb-4 secondary-text">Services</h3>
                <ul className="space-y-2">
                  {footerColumns.services.map((link, index) => (
                    <li key={`platform-${index}`}>
                      <Link
                        to={link.href}
                        className="text-sm hover:opacity-80 transition block"
                        style={{ color: 'var(--white)' }}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Column 3 - Solutions */}
              <div>
                <h3 className="text-base font-bold mb-4 secondary-text">Assesments</h3>
                <ul className="space-y-2">
                  {footerColumns.assesements.map((link, index) => (
                    <li key={`solution-${index}`}>
                      <Link
                        to={link.href}
                        className="text-sm hover:opacity-80 transition block"
                        style={{ color: 'var(--white)' }}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Column 4 - Research */}
              {/* <div>
                <h3 className="text-base font-bold mb-4" style={{ color: 'var(--white)' }}>Research</h3>
                <ul className="space-y-2">
                  {footerColumns.research.map((link, index) => (
                    <li key={`research-${index}`}>
                      <Link
                        to={link.href}
                        className="text-sm hover:opacity-80 transition block"
                        style={{ color: 'var(--white)' }}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div> */}

            </div>
          </div>

        </div>

        {/* Bottom Section - Copyright */}
        <div className="mt-8 pt-6 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm" style={{ color: 'var(--white)' }}>
              Copyright 2026 © Avexa Systems Pvt. Ltd. 
              <Link to="#" className="ml-4 hover:opacity-80 transition">Privacy Policy</Link>
              <span className="mx-2">|</span>
              <Link to="#" className="hover:opacity-80 transition">Terms & Conditions</Link>
              <span className="mx-2">|</span>
              <Link to="#" className="hover:opacity-80 transition">Contact Us</Link>
            </p>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;